import './education.css'

export default function Education() {
  return (
    <div className='educationcntr bor'>
      <div className='education'>
        <div className='firstheader bor'>
          <h1>My Education</h1>
        </div>
        <ul className='bor'>
          <li><span>Completed my SSC from J.A.K.V. high school,Alibaug
             in 2010 with 61.40%.</span></li>
          <li><span>Completed my Diploma in Computer Engineering from NJBSPM new-panvel in 2016 with 61.25%.</span></li>
          <li><span>Completed my B.E COMP from CSMIT panvel in 2020 with 6.29 CGPI.</span></li>
        </ul>
      </div>
      <div className='skills'>
        <h1 className='bor'>Certified Courses</h1>
        <div className='bor certification'>
          <div className='bor certifycntr'>
            <p>Completed certified JavaScript online course from IIHT Kharghar in November, 2021</p>
          </div>
          <div className='bor certifycntr'>
            <p>Completed certified ReactJs offline course from IIHT Kharghar in January, 2022</p>
          </div>
          <div className='bor certifycntr'>
            <p>Completed certified web designing online course in internshala training in January, 2020</p>
          </div>
          <div className='bor certifycntr'>
            <p>Completed python programming certified online training course in internshala training in February, 2020</p>
          </div>
        </div>
      </div>
    </div>
  )
}
